import * as React from "react";
import BaseModal, { RenderModalBackdropProps } from "react-overlays/Modal";
import { NoArgCallback } from "../../typings/utils";
import Button, { IButtonProps } from "../Button/Button";
import { CloseIcon } from "../Icons/Icons";
import styles from "./Modal.module.css";

export function ModalHeading({ children }: { children: React.ReactNode }) {
  return <h2 className={styles.heading}>{children}</h2>;
}

export function ModalCopy({ children }: { children: React.ReactNode }) {
  return <p className={styles.copy}>{children}</p>;
}

export function ModalInput({ children }: { children: React.ReactNode }) {
  return <div className={styles.inputWrapper}>{children}</div>;
}

export function ModalButton(props: IButtonProps) {
  return (
    <div className={styles.buttonWrapper}>
      <Button blurOnClick={true} {...props} />
    </div>
  );
}

interface IProps {
  show: boolean;
  onHide: NoArgCallback;
}

export default function Modal({ children, show, onHide }: React.PropsWithChildren<IProps>) {
  const renderBackdrop = (props: RenderModalBackdropProps) => (
    <div className={styles.backdrop} {...props} />
  );

  return (
    <BaseModal className={styles.root} renderBackdrop={renderBackdrop} show={show} onHide={onHide}>
      <div className={styles.inner}>
        <button className={styles.closeIcon} type="button" onClick={() => onHide()}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </BaseModal>
  );
}
